import { supabase } from "./supabaseClient";

export async function trackEvent(eventType, metadata = {}) {
  try {
    await supabase.from("site_events").insert({
      event_type: eventType,
      page: window.location.pathname,
      metadata,
    });
  } catch (error) {
    console.error("Metric tracking failed:", error);
  }
}

export function trackEventOncePerSession(eventType, metadata = {}) {
  const key = `metric:${eventType}:${window.location.pathname}`;

  if (sessionStorage.getItem(key)) return;

  sessionStorage.setItem(key, "true");
  trackEvent(eventType, metadata);
}